// Progresso e severidade de SLA da jornada de um cliente.
//
// Mesmo contrato do módulo de prioridade: o backend manda `progressPercent` e
// `overallPercent` prontos; estas funções são o fallback de quando o campo não
// veio, e a documentação executável da regra.
import {
  JOURNEY_STATUS,
  SLA_DIAS_ATENCAO,
  SLA_SEVERITY,
} from '@modules/client-journey/constants/Text'

const CONCLUIDA = JOURNEY_STATUS.CONCLUIDA

export function progressoDaEtapa(stage) {
  const steps = (stage && Array.isArray(stage.steps) && stage.steps) || []
  if (!steps.length) {
    // Etapa sem passos declarados: o status dela É o progresso.
    return stage && stage.status === CONCLUIDA ? 100 : 0
  }
  const feitos = steps.filter((s) => s && s.status === CONCLUIDA).length
  return Math.round((feitos / steps.length) * 100)
}

// Percentual da esteira inteira, ponderado pelo `weight` do template.
//
// NOTA: A etapa RECORRENTE fica fora do denominador: ela nunca conclui, então
// mantê-la travaria a esteira abaixo de 100% para sempre — o mesmo raciocínio
// que tira o passo sem etapa publicada do card da Home.
export function progressoDaEsteira(stages, template) {
  const lista = Array.isArray(stages) ? stages : []
  const porId = ((template && template.stages) || []).reduce((acc, s) => {
    acc[s.id] = s
    return acc
  }, {})

  let peso = 0
  let alcancado = 0
  lista.forEach((stage) => {
    const def = porId[stage.stageId] || {}
    if (def.kind === 'recorrente') return
    const w = Number(def.weight) || 1
    peso += w
    const pct =
      typeof stage.progressPercent === 'number'
        ? stage.progressPercent
        : progressoDaEtapa(stage)
    alcancado += (pct / 100) * w
  })

  if (!peso) return 0
  return Math.round((alcancado / peso) * 100)
}

// Severidade do prazo — é o que dá cor à barra na lista e ao SLA no header.
export function severidadeDoSla(signals) {
  const s = signals || {}
  if (s.slaOverdueDays === null || s.slaOverdueDays === undefined) {
    return SLA_SEVERITY.SEM_SLA
  }
  const atraso = Number(s.slaOverdueDays) || 0
  if (atraso > 0) return SLA_SEVERITY.VENCIDO
  // slaOverdueDays negativo = dias que ainda faltam.
  const faltam = Math.abs(atraso)
  if (faltam <= SLA_DIAS_ATENCAO) return SLA_SEVERITY.ATENCAO
  return SLA_SEVERITY.OK
}

// Texto curto do SLA para as métricas do header do cliente.
export function rotuloDoSla(signals) {
  const s = signals || {}
  if (s.slaOverdueDays === null || s.slaOverdueDays === undefined) return '—'
  const atraso = Number(s.slaOverdueDays) || 0
  if (atraso > 0) return `vencido há ${atraso}d`
  const faltam = Math.abs(atraso)
  if (faltam === 0) return 'vence hoje'
  return faltam === 1 ? 'vence em 1 dia' : `vence em ${faltam} dias`
}

// Primeira etapa não concluída — o ponteiro de "onde o cliente está".
export function etapaAtual(stages) {
  const lista = Array.isArray(stages) ? stages : []
  return lista.find((s) => s && s.status !== CONCLUIDA) || null
}
